import { createAction } from 'typesafe-actions';
import { BoosterType } from './BoosterType';

enum Types {
    PLAY_CARD = 'playCard',
    PLAY_BOOSTER = 'playBooster',
}

export const CardActions = {
    playCard: createAction(Types.PLAY_CARD, resolve => (cardID: string) =>
        resolve<string>(cardID)
    ),

    playBooster: createAction(
        Types.PLAY_BOOSTER,
        resolve => (type: BoosterType) => resolve(type)
    ),
};
